export default __webpack_public_path__ + "static/media/gamingUi.673357f2.png";